import '@styles/components/appBridgeMaster2023.less';
import classNames from 'classnames';
import { useState } from 'react';

const AppBridgeMaster = () => {
  let content: any = [
    {
      title: '面向桥梁',
      describe: [
        '以桥梁模型为信息主体，实现整座桥梁的设计',
        '以实际的桥梁工程对象，如盖梁、墩台身、承台、基础等作为设计对象',
        '以桥型布置图来表示完整的桥梁信息模型',
        '系统从桥梁模型中提取相关参数，自动出图',
        '保证了数据传递的一致性，避免因重复输入而导致设计错误',
      ],
      img: require('@images/home/ql_04.png').default,
      imgWidth: 250,
      imgDesc: '桥梁工程对象、设计数据读取',
    },
    {
      title: '面向设计',
      describe: [
        '建立符合工程需要的数字化桥梁',
        '自动导入路线数据',
        '自动导设计数据自动更新，避免重复设计入路线数据',
        '出图自动按结构形式和尺寸进行墩台分类',
        '多方案设计，可以在一座桥梁进行不同方案设计',
        '计算、出图、出表、统计，为用户提供了全面的解决方案',
      ],
      img: require('@images/home/ql_05.png').default,
      imgWidth: 250,
      imgDesc: '符合工程设计的桥梁模型',
    },
    {
      title: '面向工程',
      describe: ['以数据库技术为基础，实现面向工程（整条路线）的桥梁设计'],
      describeLi: [
        '利用数据库全面管理工程、项目、图纸',
        '批量定制全线的标准图纸，批量生成桥型、构造等图纸',
        '标准化设计，制图标准和出图风格统一',
      ],
      img: require('@images/home/ql_06.png').default,
      imgWidth: 250,
      imgDesc: '工程批量处理',
    },
    {
      title: '多专业协同设计',
      describe: [
        '实现纬地、二院路线(BRF格式)、EICADDICAD全新格式路线数据一键转换功能',
        '理正MDB数据库文件一键生成钻孔文件',
        '导入钻孔标准层',
      ],
      img: require('@images/home/ql_07.png').default,
      imgWidth: 250,
      imgDesc: '路线资料和地质资料转换',
    },
    {
      title: '便捷的变更设计',
      describe: [
        '当设计资料或设计标准图发生变化时，通过变更设计功能可实现系统自动修改，避免重复设计',
      ],
      describeLi: [
        '布梁模型变更设计后，自动影响桥梁模型',
        '采用参考图框样式，自动变更图框设计',
        '桥梁模型变更后，自动更新构造图、桩位坐等相关图纸',
        '变更设计使桥梁大师设计更简单，操作更方便',
      ],
      img: require('@images/home/ql_08.png').default,
      imgWidth: 250,
      imgDesc: '符合工程设计的桥梁模型',
    },
    {
      title: '自动计算',
      describe: [
        '结合桥梁设计模型，自动计算横坡、高程、桩位坐标等参数 ',
        '盖梁计算、桩长计算等模块，既可与设计模型关联，也可作为独立工具使用 ',
        '钢筋图中，钢筋折减以及弯勾增长都符合规范要求，并提供多种布筋方式选择，满足不同用户的设计需求',
      ],
      img: require('@images/home/ql_12.png').default,
      imgWidth: 250,
      imgDesc: '桩长计算',
    },
    {
      title: '自动全桥工程量统计',
      describe: [
        '提供交互工具可随时查看各构件的工程量和材料明细、自动汇总全桥的工程材料数量，生成全桥的工程数量表。表格形式可定制、内容可编辑、版式可自动调整，可以将全桥工程资料输出成Excel表格。',
      ],
      img: require('@images/home/ql_14.png').default,
      imgWidth: 250,
      imgDesc: '全桥工程量自动统计',
    },
    {
      title: '曲线、斜交、变宽布梁设计',
      describe: [
        '可以选择墩台径向布置或平行布置',
        '提供多种布梁方式',
        '交互修改布梁信息',
        '变宽桥布梁优化悬臂或湿接缝设计',
        '自动影响桥梁模型',
        '自动生成主梁布置图',
      ],
      img: require('@images/home/ql_10.png').default,
      imgWidth: 165,
      imgDesc: '布梁设计方式',
    },
    {
      title: '自动分类出图、出表',
      describe: [
        '桥梁模型设计完成后，按照结构形式和设计参数自动进行墩台分类',
        '自动提取设计模型数据生成构造图、钢筋图',
        '自动生成墩台设计参数表、工程数量表等',
      ],
      img: require('@images/home/ql_13.png').default,
      imgWidth: 165,
      imgDesc: '基于桥梁模型自动图纸分类、生成参数表',
    },
  ];
  let updateContent: any = [
    {
      title: '新增功能',
      content: [
        '1、支持互通连接部位置预制梁布梁设计，支持直线布置和折线布置。',
        '2、改进L盖梁设计方法，支持桥墩偏心设计，按固定盖梁高低处差值计算标高。',
        '3、单幅双向坡时，桥梁墩台支持顶底同坡设计。',
        '4、桩接柱系梁支持台阶设计。',
        '5、改进一般构造图出图排版规则，自动调整图纸布局位置，减少图面重叠的情况。',
        '6、支持在布梁模型里直接修改梁片数。',
        '7、布梁影响模型时，增加盖梁取整功能。同时放开梁和挡块间最小缝隙，用户可以自定义。',
        '8、增加更新盖梁功能，执行命令后，在布梁模型里，重绘布梁影响以后桥型图中的下部墩台。',
        '9、桥墩标准图中增加连续墩属性。',
        '10、建立模型增加不考虑桥宽的功能。',
        '11、无盖梁柱式墩，增加盖中距离参数，可以调整无盖梁柱式墩横向位置。',
        '12、新增耳墙钢筋图。',
        '13、新增支座型号设置。',
        '14、增加支座布置图，可以绘制支座的位置，统计支座的个数。',
        '15、增加绘制边线功能，可以绘制横断面桥梁边线，辅助检查数据资料与总体图的关系。',
        '16、增加复制项目的功能，选中桥梁，右键可以复制项目，便于不同设计阶段的项目引用。',
      ],
    },
    {
      title: '优化功能',
      content: [
        '1、改进桥位平面布置图锥坡绘制，支持按实际地面线绘制方式。',
        '2、改进桥位平面布置图中路线参数表，支持输出多个交点参数。',
        '3、改进桥型布置图立面标注竖向间距，避免字体样式为仿宋_GB2312，字高为2.5时，标注压线的问题。',
        '4、双幅桥只设计一幅时，增加桥梁总宽标注，适用于分离式路基。',
        '5、改进桥型布置图分图功能。',
        '6、桥墩一般构造图增加不出参数表的功能，采用直接标注的样式生成图纸。',
        '7、改进盖梁钢筋图箍筋设置，可支持12肢箍筋。',
        '8、改进L盖梁钢筋图，支持斜交L型盖梁钢筋图设计。',
        '9、改进薄壁墩、轻型墩钢筋图。',
        '10、改进轻型台钢筋图。',
        '11、改进实体承台钢筋，支持斜交实体承台钢筋图。',
        '12、改进上部构造尺寸表，变宽布梁后，支持分A、B端输出梁间距。',
      ],
    },
    {
      title: '修复问题',
      content: [
        '1、修复路线存在负桩号时，桥型布置图卡死的情况。',
        '2、修复按照互通匝道方式做的横断面格式，不支持预制梁布梁、桥型布置图分岔位置上部横断面错误的问题。',
        '3、修复当一个桥梁内，同时存在先简支后连续和桥面连续时，布梁模型中，不读取工程配置中桥面连续缝半宽值的问题。',
        '4、修复变宽布梁时，桥墩标准图中墩柱个数大于2以后，自动计算桥墩错误的问题。',
        '5、修复布梁影响时，盖梁斜做正置后出现的错误。',
        '6、修复变宽桥布梁后，部分墩台构造图垫石位置和标高错误问题。',
        '7、改进布梁影响模型算法，解决单幅桥曲线变宽段一般构造图中桥台C值输出错误问题。',
        '8、修复部分桥梁平行布置，根据布梁影响模型后，C值输出错误问题。',
        '9、修复柱式墩桩间距不等后，桥位平面布置图桩基错位、桩位坐标图坐标错误的问题。',
        '10、修复左右幅错幅桥梁，部分情况下桩位坐标输出错误的问题。',
        '11、修复桥墩采用分离式承台时，多排桩基时，桥位平面布置图桩位绘制错误。',
        '12、修复扶壁台斜桥斜做后，边侧腹板斜交角度错误的问题。',
        '13、修复小箱梁一端双支座，一端单支座布置时，桥墩一般构造图支座个数和支座距离标注错误问题。',
        '16、修复部分情况下挡块钢筋错误的问题。',
        '17、修复座板台不能出承台钢筋构造图和盖梁钢筋构造图的问题。',
        '18、修复桩柱式钢筋，调用标准图时，定位钢筋数据错误问题。',
        '19、修复双幅左右幅不等跨的桥，出桩基构造图时，右幅参数错误的问题。',
        '20、更改另存为功能工程配置里基本参数的保存路径方式，解决提示不是当前项目的问题。',
      ],
    },
  ];

  const ListsContentJsx = content.map((item: any, idx: number) => {
    return (
      <div className="content-item" key={idx}>
        <div className={'content-title2023'}>
          <span className={'text'}>{item.title}</span>
          <span className={'line'} />
        </div>
        {item.describe.map((desc: any, idx: number) => {
          return (
            <div className={'introducenew'} key={idx}>
              {desc}
            </div>
          );
        })}
        {item.describeLi &&
          item.describeLi.map((li: any, idx: number) => {
            return (
              <div className={'introduceLi'} key={idx}>
                {li}
              </div>
            );
          })}
        <div className={'text-center'}>
          <img style={{ width: `calc(100vw -  ${375 - item.imgWidth}px) ` }} src={item.img} alt="" />
          <p className={'qldsimgj'}>{item.imgDesc}</p>
        </div>
      </div>
    );
  });

  const [index, setIndex] = useState(0);
  function tabChange(idx: number) {
    setIndex(idx);
  }

  const UpdateContentBtnJSX = updateContent.map((item: any, idx: number) => {
    return (
      <div
        className={classNames('update-btn', { active: idx === index })}
        onClick={() => tabChange(idx)}
        key={idx}
      >
        {item.title}
      </div>
    );
  });

  let activeItem = updateContent[index];
  const UpdateContentJSX = activeItem.content.map((li: any, idx: number) => {
    return (
      <div className="updateLi" key={idx}>
        {li}
      </div>
    );
  });

  return (
    <div className={'app-display-desc'}>
      <div className={'intro-bg'}>
        <div className={'content-introduction'}>
          桥梁大师提出了的参数化、批量化桥梁设计思想，采用面向对象、面向桥梁、面向工程的建模技术，软件操作简单、使用方便，受到广大用户一致好评。桥梁大师可用于各种弯、坡、斜等大中小桥设计，可用于整体式路基、分离式路基的双幅桥和单幅桥设计，可完成左右幅路基宽度相同或不同、墩台形式相同或不同、错墩、错台等复杂桥梁设计。软件适用范围广，可满足公路、市政、铁路、港航等不同行业的桥梁设计任务。
        </div>
        <div className={'bridgeMaster-list'}>
          <div className={'border'}>
            <span className={'type'}>K（快）</span>
            <span className={'type-introduce'}>更快捷、更轻松的工作</span>
          </div>
          <div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>自动导入路线数据</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>自动套用标准图</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>自动交互设计，属性设计、尺寸驱动</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>拖动修改</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>自动分类汇总、出图、出表</span>
            </div>
          </div>
        </div>
        <div className={'bridgeMaster-list'}>
          <div className={'border'}>
            <span className={'type'}>S（实）</span>
            <span className={'type-introduce'}>解决实实在在的问题</span>
          </div>
          <div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>错墩台等复杂桥型设计</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>变更设计</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>横坡、高程任意调整</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>斜弯桥、变宽桥布梁设计</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>桩位坐标自动计算</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>桥位平面图</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>工程量统计</span>
            </div>
          </div>
        </div>
        <div className={'bridgeMaster-list'}>
          <div className={'border'}>
            <span className={'type'}>J（精）</span>
            <span className={'type-introduce'}>更精细、更精准的设计</span>
          </div>
          <div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>数据一次输入</span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>所见即所得，问题一目了然 </span>
            </div>
            <div>
              <span className={'list-d'}>●</span>
              <span className={'list-text'}>甲级设计院校验</span>
            </div>
          </div>
        </div>
        <div className="more-box">
          <div className="more-item">
            <img
              style={{ width: '19px', margin: '12px 0 10px 0' }}
              src={require('@images/bridgeMaster/efficiency.png').default}
              alt=""
            />
            <div className="more-desc">更高的设计效率</div>
          </div>
          <div className="more-item">
            <img
              style={{ width: '19px', margin: '10px 0 7px 0' }}
              src={require('@images/bridgeMaster/quality.png').default}
              alt=""
            />
            <div className="more-desc">更好的设计质量</div>
          </div>
          <div className="more-item">
            <img
              style={{ width: '23px', margin: '11px 0 8px 0' }}
              src={require('@images/bridgeMaster/work.png').default}
              alt=""
            />
            <div className="more-desc">更轻松的设计工作</div>
          </div>
          <div className="more-item">
            <img
              style={{ width: '23px', margin: '10px 0 8px 0' }}
              src={require('@images/bridgeMaster/option.png').default}
              alt=""
            />
            <div className="more-desc">更高水平的设计方案</div>
          </div>
        </div>
      </div>
      <div className="lists-box">
        <div className="line-string"></div>
        {ListsContentJsx}
      </div>
      <div className="update-box">
        <div className="update-title">桥梁大师2023更新内容</div>
        <div className="flex update-btn-box">{UpdateContentBtnJSX}</div>
        <div className="li-box">{UpdateContentJSX}</div>
      </div>
    </div>
  );
};

export default AppBridgeMaster;
